import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-fulle-page-loader',
  templateUrl: './fulle-page-loader.component.html',
})
export class FullePageLoaderComponent implements OnInit {

  @Input() loader: boolean|any;
  @Input() pointOfSale: any;
  @Input() OpenOnInitDialog: any;

  domainUser:any;
  url: string = this.router.url;
  logoLink: string|any;

  constructor(private router: Router, private tools: ToolsService) {

   }

  ngOnInit() {
    this.domainUser=this.tools.getStor("domainUser")?this.tools.getStor("domainUser"):null;
      this.setLogoLink();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["pointOfSale"] && changes["pointOfSale"].currentValue) {
      this.setLogoLink();
    }
  }

  setLogoLink(): void {
    this.logoLink = (this.pointOfSale && this.pointOfSale.img) ? this.pointOfSale.img :this.domainUser ? null: "assets/img/logo/logo-fulle-xs.png";
  }

}
